import { Select as ReactSelect } from './SelectStyles';
import createSelectComponent from './SelectFactory';
var Select = createSelectComponent(ReactSelect);
export default Select;